/* eslint-disable camelcase */
import React from "react"
import { auditShape } from "utils/propTypeShapes"

const AccessLevelGrantAccessLevelChangedAuditItemDetails = ({ audit }) => {
  const {
    associatedType, auditedChanges, grantee, solutionName,
  } = audit
  const { access_level = {} } = auditedChanges
  const { from: oldAccessLevel, to: newAccessLevel } = access_level

  const renderAccessToObject = () => {
    if (associatedType === "Category") {
      return <span className="font-semibold">{solutionName}</span>
    }
    return ""
  }

  return (
    <div>
      Changed the {renderAccessToObject()} access level grant to <span className="font-semibold">{grantee.fullName}</span> {oldAccessLevel && ` from ${oldAccessLevel}`}{newAccessLevel && ` to ${newAccessLevel}`}.
    </div>
  )
}

AccessLevelGrantAccessLevelChangedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default AccessLevelGrantAccessLevelChangedAuditItemDetails
